import ModalCondenser from './ModalCondenser';

export default ModalCondenser;
